import { render, staticRenderFns } from "./Accesslist.vue?vue&type=template&id=0f018da0&scoped=true"
import script from "./Accesslist.vue?vue&type=script&lang=js"
export * from "./Accesslist.vue?vue&type=script&lang=js"
import style0 from "./Accesslist.vue?vue&type=style&index=0&id=0f018da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f018da0",
  null
  
)

export default component.exports